// @ts-nocheck
import { ClickableProps } from "@insite/mobius/Clickable";
import { IconPresentationProps } from "@insite/mobius/Icon";
import TextField, { TextFieldPresentationProps, TextFieldProps } from "@insite/mobius/TextField";
import Eye from "@store/Library/Components/Toolkit/Icons/Eye/EyeLine";
import EyeOff from "@store/Library/Components/Toolkit/Icons/EyeOff/EyeOffLine";
import React, { EventHandler, FC, useMemo, useState } from "react";

export interface PasswordFieldPresentationProps extends TextFieldPresentationProps {}

export interface PasswordFieldProps extends Omit<TextFieldProps, "type"> {
    id: string;
}

/**
 * A password `TextField` with a show/hide toggle. The `id` is required because it wires the toggle's
 * `aria-controls` to the input it reveals.
 */
const PasswordField: FC<PasswordFieldProps> = ({ id, iconProps, iconClickableProps, ...otherProps }) => {
    const [showPassword, setShowPassword] = useState(false);

    const toggleIconProps = useMemo<IconPresentationProps>(
        () => ({ ...iconProps, src: showPassword ? EyeOff : Eye }),
        [iconProps, showPassword],
    );

    const toggleClickableProps = useMemo<ClickableProps>(() => {
        const onClick: EventHandler<React.MouseEvent> = event => {
            setShowPassword(current => !current);
            iconClickableProps?.onClick?.(event);
        };

        return {
            ...iconClickableProps,
            onClick,
            "aria-controls": id,
            "aria-expanded": showPassword,
        };
    }, [iconClickableProps, id, showPassword]);

    return (
        <TextField
            id={id}
            type={showPassword ? "text" : "password"}
            iconProps={toggleIconProps}
            iconClickableProps={toggleClickableProps}
            {...otherProps}
        />
    );
};

export default PasswordField;
